import styled from '@emotion/styled';

const Alert = styled.div`
  ${(props) =>
    props.info &&
    `
      color: #0c5460;
      background-color: var(--info);
      border-color: #bee5eb;
    `}

  ${(props) =>
    props.warning &&
    `
      color: #4e4f0a;
      background-color: var(--warn);
      border-color: #ebeabe;
    `}

  ${(props) =>
    props.success &&
    `
      color: #0c6010;
      background-color: var(--msuccess);
      border-color: #beebbf;
    `}

  ${(props) =>
    props.error &&
    `
      color: #600c0c;
      background-color: var(--error);
      border-color: #ebbebe;
    `}
    

  position: relative;
  padding: 0.75rem 1.25rem;
  margin-bottom: 1rem;
  border: 1px solid transparent;
  border-radius: 0.25rem;

  :before {
    content: '';
    position: absolute;
    width: 0;
    height: calc(100% - 44px);
    border-left: 1px solid;
    border-right: 2px solid;
    border-bottom-right-radius: 3px;
    border-top-right-radius: 3px;
    left: 0;
    top: 50%;
    transform: translate(0, -50%);
    height: 20px;
  }

  button {
    font-size: 100%;
    font-family: inherit;
    border: 0;
    padding: 0;
    background-color: inherit;
  }
`;

export { Alert };
